


export type projectRoute = {[key:string]:string }
export type SubProjectInfo = {id?:number,name:subProjectNameType,title?:string}

export type  subProjectNameType = 'erp';
export const  defaultSubProjectName:subProjectNameType = "erp";


export const DefaultSubProjectInfo:SubProjectInfo = {id:undefined,name:defaultSubProjectName,title:undefined}

export interface BaseLoginProps {
    subProjectInfo:SubProjectInfo,
    useOrganization?:boolean



}